<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <h1 slot="title" class="mt-2 text-uppercase text-left font-weight-bold">
        <a href="#" @click.prevent="goBack"><i class="fa fa-angle-left"></i></a>
        Trazabilidad: guia recepción (<span v-if="numGuia">{{ numGuia }})</span>
      </h1>
      <b-row>
        <b-col cols="12">
          <b-card header-tag="header" footer-tag="footer">
            <b-spinner class="text-center" v-if="!waybill"></b-spinner>
            <div class="text-center" v-if="waybill">
              <div class="table-responsive-sm">
                <table class="table table-sm">
                  <thead>
                    <tr class="font-weight-bold text-uppercase">
                      <th class="text-center">#</th>
                      <th class="align-middle">Pallet</th>
                      <th class="align-middle">Lote</th>
                      <th class="align-middle">Huerto <br />(CSG)</th>
                      <th class="align-middle">Especie <br />Tipo</th>
                      <th class="align-middle">Variedad</th>
                      <th class="align-middle">Env./Emb.</th>
                      <th class="align-middle">Spec</th>
                      <th class="text-center align-middle">Cantidad</th>
                      <th class="text-right align-middle">Kg Netos</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(item, index) in waybill.pallets">
                      <tr>
                        <td :rowspan="item.contents.length + 1" class="text-center align-middle">{{ index + 1 }}</td>
                        <td :rowspan="item.contents.length + 1" class="left align-middle">
                          <a
                            target="_blank"
                            href="#"
                            title="Ver en detalle"
                            @click.prevent="seeDetailContent(item.id, item.number)"
                          >
                            {{ item.number }}
                          </a>
                        </td>
                      </tr>
                      <tr v-for="content in item.contents">
                        <td class="left align-middle">
                          <a
                            target="_blank"
                            href="#"
                            title="Ver en detalle"
                            @click.prevent="seeLotDetail(item.receipt_waybill, content.lot_number)"
                          >
                            {{ content.lot_number }}
                          </a>
                        </td>
                        <td class="left align-middle">
                          {{ content.origin_details.name }} <br />({{ content.origin_details.code }})
                        </td>
                        <td class="left align-middle">
                          {{ content.product_name }} <br />{{ content.product_type_name }}
                        </td>
                        <td class="left align-middle">
                          {{ content.variety_name }} <br />
                          {{ content.condition }}
                        </td>
                        <td class="left align-middle">{{ content.container.value.name }}</td>
                        <td class="left align-middle">{{ content.string_specs }}</td>
                        <td class="text-center align-middle">{{ content.quantity }}</td>
                        <td class="text-right align-middle">{{ content.net_kilograms }} Kg</td>
                      </tr>
                    </template>
                  </tbody>
                  <tfoot>
                    <tr class="font-weight-bold">
                      <td class="text-center"></td>
                      <td class="left"></td>
                      <td class="left"></td>
                      <td class="left"></td>
                      <td class="left"></td>
                      <td class="left"></td>
                      <td class="left"></td>
                      <td class="text-right">TOTALES</td>
                      <td class="text-center">{{ waybill.total_quantity }}</td>
                      <td class="text-right">{{ waybill.total_kilograms | decimal }} Kg</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ClientTable, Event } from "vue-tables-2";

import miniToastr from "mini-toastr";

const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};

miniToastr.init({ types: toastTypes });

Vue.use(ClientTable);

export default {
  name: "detailedWaybillReception",
  props: ["waybill_id", "numGuia"],
  created() {},
  data() {
    return {
      waybill: null
    };
  },
  methods: {
    getCompleteWaybill(a) {
      this.$axios
        .get("/api/v1/waybill/" + a + "/waybill_complete/")
        .then((res) => {
          this.waybill = res.data;
        })
        .catch((error) => console.log(error));
    },
    seeDetailContent(id_pallet, numero_pallet) {
      this.$router.push("/trazabilidad/detailed-pallet-trazability/" + id_pallet + "/" + numero_pallet);
    },
    seeLotDetail(waybill_id, numLote) {
      if (waybill_id != null) {
        this.$router.push("/trazabilidad/detailed-lote/" + waybill_id + "/" + numLote);
      } else {
        miniToastr.info("Sin Informacion", "");
      }
    },
    goBack() {
      this.$router.go(-1);
    }
  },
  mounted() {
    this.getCompleteWaybill(this.waybill_id);
  }
};
</script>
